import { Stack } from "@mui/material";
import SettingCard from "@/components/SettingCard";
import BackgroundSettings from "@/components/editor/settings/BackgroundSettings/BackgroundSettings";
import ClassSettings from "@/components/editor/settings/ClassSettings";
import DisplaySettings from "@/components/editor/settings/DisplaySettings/DisplaySettings";
import SpacingSettings from "@/components/editor/settings/SpacingSettings/SpacingSettings";
import DimentionSettings from "@/components/editor/settings/DimentionSettings/DimentionSettings";
import BorderRadiusSettings from '@/components/editor/settings/BorderRadius/BorderRadiusSettings';

export const ContainerSettings = () => {
    return (
      <Stack spacing={2}>       
        {/* ✅ */}
        <SettingCard title="Clase Css">
          <ClassSettings />
        </SettingCard>
        <SettingCard title="Visualización">
          <DisplaySettings />
        </SettingCard>
        <SettingCard title="Espaciado">
          <SpacingSettings />
        </SettingCard>
        <SettingCard title="Fondo">
          <BackgroundSettings />
        </SettingCard>
        <SettingCard title="Tamaño">
          <DimentionSettings />
        </SettingCard>
        <SettingCard title="Bordes Redondeados">
          <BorderRadiusSettings />
        </SettingCard>
      </Stack>
    );
};

export default ContainerSettings;
